module.exports = __webpack_public_path__ + "img/steam-engine-V-shadow.aa2a4865.png";